<template>
  <div>
    <menu-list-add-new
      :is-add-new-menu-sidebar-active.sync="isAddNewMenuSidebarActive"
      :category-options="categoryOptions"
      :id="id"
      @refetch-data="refetchData"
    />
    <menus-category
      :category-options="categoryOptions"
      :categoryTableColumns="categoryTableColumns"
      @fetch-menu-categories="fetchMenuCategories"
      @refetch-data="refetchData"
    />
    <!-- <button @click="fetchMenuCategories">update</button> -->
      <!-- :key="trigger" -->
    <b-card no-body class="mb-0">

        <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="4"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entries</label>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="8"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Search..."
              />

              <!-- Category Filter -->
              <v-select
                v-model="selectedCategory"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="categoryOptions"
                class="category-selector d-inline-block mr-1"
                placeholder="Filter by Category"
                :clearable="true"
              />

              <b-button
                variant="primary"
                @click="handleAdd()"
              >
                <span class="text-nowrap">Add Menu</span>
              </b-button>

              <b-button
                variant="primary"
                v-b-modal.modal-menu-category
                style="margin-left: 10px"
              >
                <span class="text-nowrap">Menu Category</span>
              </b-button>
            </div>
          </b-col>
        </b-row>

      </div>

        <b-table
        ref="refMenuListTable"
        class="position-relative"
        :items="fetchMenus"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
        >
        <template #cell(menu_title)="data">
            <b-media vertical-align="center">
             <template #aside>
              <b-avatar
                size="32"
                :src="getMenuImage(data.item.image)"
                icon="alarm"
                variant="primary"

              />
            </template>
              {{ data.item.menu_title }}
          </b-media>
        </template>
         <template #cell(menu_category_id)="data">
              {{ data.item.category.name }}
        </template>
        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>

            <b-dropdown-item @click="editMenu(data.item.id)">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Edit</span>
            </b-dropdown-item>

            <b-dropdown-item @click="confirmDelete(data.item.id)">
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">Delete</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
        </b-table>
        <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalMenus"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
} from "bootstrap-vue";
import vSelect from "vue-select";
import store from "@/store";
import { ref, onUnmounted, onMounted } from "@vue/composition-api";
import { avatarText } from "@core/utils/filter";
import axiosIns from "@/libs/axios";
import menuStoreModule from "../menuStoreModule";
import useMenusList from './useMenusList'
import MenuListAddNew from './MenuListAddNew.vue';
import MenusCategory from '../menus-category/MenusCategory.vue'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,

    vSelect,
    MenuListAddNew,
    MenusCategory

  },
  methods:{
    handleAdd(){
      this.id = 0
      this.isAddNewMenuSidebarActive = true
    },
    confirmDelete(id) {
        this.$swal({
        title: 'Are you sure?',
        text: "Your action is final and you are not able to recover the data.",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          store.dispatch('bar-menu/deleteMenu', id)
          .then((response) => {
            this.refetchData()
            this.showMessage('Success', response.data.message, 'CheckIcon', 'success')

          }).catch( error => {
              this.showMessage('Fail', error.response.data.message, 'HeartIcon', 'danger')
          })

        }
      })
    },
    editMenu(id){
        console.log(id)
        this.id = id
        this.isAddNewMenuSidebarActive = true
    }
  },
  data(){
    return {
      id:0,
    }
  },
  watch: {
    categoryOptions: {
      handler(newCategories) {
        console.log('newCategories', newCategories)
      },
      deep: true, // Add the deep option to trigger on nested changes
      immediate:true
    }
  },
  setup() {
    const BAR_MENU_STORE_MODULE_NAME = "bar-menu";
    const isAddNewMenuSidebarActive = ref(false);

    if (!store.hasModule(BAR_MENU_STORE_MODULE_NAME))
      store.registerModule(BAR_MENU_STORE_MODULE_NAME, menuStoreModule);

    onUnmounted(() => {
      if (store.hasModule(BAR_MENU_STORE_MODULE_NAME))
        store.unregisterModule(BAR_MENU_STORE_MODULE_NAME);
    });


    const {

        fetchMenus,
        fetchMenuCategories,
        tableColumns,
        perPage,
        currentPage,
        totalMenus,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refMenuListTable,
        refetchData,
        getMenuImage,
        categoryOptions,
        categoryTableColumns,
        showMessage,
        selectedCategory

    } = useMenusList()

    return {

        //SideBar
        isAddNewMenuSidebarActive,

        fetchMenus,
        fetchMenuCategories,
        tableColumns,
        perPage,
        currentPage,
        totalMenus,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refMenuListTable,
        refetchData,
        getMenuImage,
        categoryOptions,
        categoryTableColumns,
        showMessage,
        selectedCategory

    }
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px !important;
}

.category-selector {
  width: 250px !important;
  min-width: 250px !important;
  max-width: 250px !important;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>

